import { EuiFlexGroup, EuiFlexItem, EuiIcon } from "@inscopix/ideas-eui";
import { ColorsByTaskStatus } from "types/ColorsByTaskStatus";
import { TaskStatus } from "types/constants";
import { useModalContext } from "providers/ModalProvider/ModalProvider";
import { GdtAnalysisTableRow, Task } from "graphql/_Types";
import { ModalTaskLogs } from "components/ButtonViewTaskLogs/ModalTaskLogs";
import { Tooltip } from "components/Tooltip/Tooltip";
import { includes } from "lodash";
import { ReactComponent as IconBolt } from "assets/bolt.svg";

interface TaskStatusAndLogIconProps {
  taskId: Task["id"];
  taskStatus: TaskStatus;
  taskCreated: Task["dateCreated"];
  isCached: GdtAnalysisTableRow["cached"];
}

export const TaskStatusIcon = ({
  taskId,
  taskStatus,
  taskCreated,
  isCached,
}: TaskStatusAndLogIconProps) => {
  const color = ColorsByTaskStatus[taskStatus];
  const taskStatusName = TaskStatus[taskStatus];
  const showTaskLog = includes(
    [TaskStatus["COMPLETE"], TaskStatus["ERROR"], TaskStatus["FAILED"]],
    taskStatus,
  );
  const { openModal, closeModal } = useModalContext();

  const showModal = () =>
    openModal(
      <ModalTaskLogs
        task={{ id: taskId, status: taskStatus, dateCreated: taskCreated }}
        onClose={closeModal}
      />,
    );

  const tooltipContent = (
    <EuiFlexGroup direction="column" gutterSize="xs" responsive={false}>
      <EuiFlexItem grow={false} style={{ color }}>
        {taskStatusName}
      </EuiFlexItem>
      {isCached && (
        <EuiFlexItem grow={false}>
          <EuiFlexGroup alignItems="center" gutterSize="xs" responsive={false}>
            <EuiFlexItem grow={false}>
              <EuiIcon type={IconBolt} aria-hidden />
            </EuiFlexItem>
            <EuiFlexItem grow={false}>Cached result</EuiFlexItem>
          </EuiFlexGroup>
        </EuiFlexItem>
      )}
      {showTaskLog && <EuiFlexItem grow={false}>View task logs</EuiFlexItem>}
    </EuiFlexGroup>
  );

  return (
    <Tooltip content={tooltipContent}>
      <EuiIcon
        data-test-id={`task-status-icon-${taskStatusName}`}
        aria-label="View task logs"
        type="stopFilled"
        size="l"
        color={color}
        style={{ cursor: showTaskLog ? "pointer" : "default" }}
        onClick={() => showTaskLog && showModal()}
      />
    </Tooltip>
  );
};
